import React, { Component } from 'react';

class BlurWrap extends Component {

    constructor ( props ) {
        super ( props );
        this.state = {
            renderChildren: false
        };
    };

    componentDidMount () {
        this.props.setCanvas ( this.newRef );
        this.setState ( { renderChildren: true } );
    };

    componentDidUpdate ( prevProps ) {
        if ( this.props.children.props.question
            && prevProps.children.props.question
            && ( this.props.children.props.question.id != prevProps.children.props.question.id ) ) {
            this.props.timerDidUprate ();
        }
    };

    render () {
        return (
            <div>
                { this.state.renderChildren && this.props.children }
            </div>
        );
    };
};

export default BlurWrap;